import { DealerShareBuilder } from './dealer.share';
import { URLService } from '../url.service';

export class ActivityH5ShareBuilder extends DealerShareBuilder {
  constructor({ dealerInfo, shareInfo, activityInfo, shareLink }) {
    super({ dealerInfo, shareInfo });
    this.activityInfo = activityInfo;
    this.shareLink = shareLink;
  }
  buildShareData() {
    const { title, activityId, activityType, pvareaid, remainDays } =
      this.activityInfo;
    let shareUrl = this.buildActShareUrl(activityType, activityId, pvareaid);
    const desc = `距报名截止时间还有${remainDays}天`;
    const shareInfo = this.shareInfo
    return {
      isNative: true,
      platform: 'weixin&weixincircle',
      hideMiniProgram: true,
      shareUrl,
      title,
      desc: desc,
      link: shareUrl,
      icon: shareInfo && shareInfo.dealerImage
    };
  }
  buildActShareUrl(activityType, activityId, pvareaid) {
    let urlService = new URLService(this.shareLink);
    urlService.queryParams
      .remove('pvareaid')
      .remove('activityType')
      .remove('activityId')
      .append('pvareaid', pvareaid)
      .append('activityType', activityType)
      .append('activityId', activityId);
    let shareUrl = urlService.build();
    return shareUrl;
  }
}
